import { Api } from 'api';

export class AuthService {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  public forgotPassword(username: string) {
    return this.api.request<any>({
      method: 'POST',
      uri: '/account/forgot-password',
      qs: {
        username,
      },
    });
  }

  public resetPassword(username: string, token: string, newPassword: string) {
    return this.api.request<any>({
      method: 'POST',
      uri: '/account/reset-password',
      body: JSON.stringify({
        username,
        token,
        newPassword,
        shouldReset: '',
      }),
    });
  }
}
